import React from 'react'

import { connect } from 'react-redux'
import { Link, withRouter, RouteComponentProps } from 'react-router-dom'
import { Container, Card, Button } from 'react-bootstrap'

import { userCan } from 'src/store/user/userActions'
import { useQuery, route } from 'src/utils/routes'
import { IState } from 'src/store'

import Error401 from 'src/pages/Error/401.page'
import Header from 'src/components/Layout/Header/Header'
import CompetitionForm from 'src/components/Competition/CompetitionForm'
import CompetitionUpload from 'src/components/Competition/CompetitionUpload'

interface IProps extends RouteComponentProps {
  history: any
  user: any
  userCan: (permission: string) => boolean
}

const CompetitionCreate: React.FC<IProps> = ({ history, user, userCan }) => {
  const type = useQuery().get('type')

  if (!userCan('create_competition')) return <Error401 />

  return (
    <>
      <Header
        title={type === 'bulk' ? 'Upload Bulk' : 'New Competition Product'}
        backText="Competition Products"
        onBack={() => history.push(route('competition'))}
      />
      <div className="page-container">
        <Container>
          <Card className={type === 'bulk' ? 'centered' : null}>
            <Card.Header className="w-100 d-flex align-items-center">
              <Card.Title>
                {type === 'bulk'
                  ? 'Upload File'
                  : 'Competition Product Details'}
              </Card.Title>

              {type !== 'bulk' && userCan('create_competition') && (
                <div>
                  <Link to={`${route('competition_create')}?type=bulk`}>
                    <Button size="sm">Create Bulk</Button>
                  </Link>
                </div>
              )}
            </Card.Header>
            <Card.Body className="pt-0">
              {type === 'bulk' ? (
                <CompetitionUpload user={user} />
              ) : (
                <CompetitionForm user={user} />
              )}
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  )
}

export default connect((state: IState) => ({ user: state.user }), { userCan })(
  withRouter(CompetitionCreate)
)
